// var languageType = require('./languageCommon.js')
var languageType = require('./languageCommon.js')
var language = localStorage.getItem('language') || 'zh-CN'
if(language=='zh-CN'){
    document.getElementsByTagName('meta')[1].setAttribute('content',suoxingmeta[language])
    document.getElementsByTagName('meta')[2].setAttribute('content',suoxingkey[language])
    document.title = suoxingtitle[language];
}else{
    document.getElementsByTagName('meta')[1].setAttribute('content',suoxingmeta['USA'])
    document.getElementsByTagName('meta')[2].setAttribute('content',suoxingkey['USA'])
    document.title = suoxingtitle['USA'];
    // document.getElementsByTagName('title')[1].setAttribute('content',grouptitle['USA'])
}

$('.suoxinBuildingaboutfbType1').html(suoxinBuildingaboutfbType1[language])
$('.suoxinBuildingaboutfbType2').html(suoxinBuildingaboutfbType2[language])

$('.commonlanguage').html(commonlanguage[language])
$('title').html(simplyTitle[language]);
$('.commonHomePage').html(commonHomePage[language]);
$('.commonLvyue').html(commonLvyue[language]);
$('.commonAboutLvyue').html(commonAboutLvyue[language]);
$('.commonlvyueBrand').html(commonlvyueBrand[language]);
$('.commonFlowerConstruction').html(commonFlowerConstruction[language]);
$('.commonFloralLux').html(commonFloralLux[language]);
$('.commonClaim').html(commonClaim[language]);
$('.commonWeiLai').html(commonWeiLai[language]);
$('.commonTanChen').html(commonTanChen[language]);
$('.commonflowerTravel').html(commonflowerTravel[language]);
$('.commonJoinInCooperation').html(commonJoinInCooperation[language]);
$('.commonPanorama').html(commonPanorama[language]);
// $('.commonPaidInformation').html(commonPaidInformation[language]);
$('.commonZh').html(commonZh[language]);
$('.commonUsa').html(commonUsa[language]);
$('.commonJp').html(commonJp[language]);
$('.commonKo').html(commonKo[language]);
$('.commonTh').html(commonTh[language]);
$('.commonYh').html(commonYh[language]);
$('.commonReservations a').html(commonReservations[language]);
$('.commonClose').html(commonClose[language]);
$('.commonFreebooking').html(commonFreebooking[language]);
$('.commonDownload').html(commonDownload[language]);
$('.commonWechatSubscription').html(commonWechatSubscription[language]);
$('.commonHuazhuSubscription').html(commonHuazhuSubscription[language]);
$('.commonBrandintroductio').html(commonBrandintroductio[language]);
$('.commonWantJoin').html(commonWantJoin[language]);
$('.commonConectUs').html(commonConectUs[language]);
$('.commonCustomerServiceHotline').html(commonCustomerServiceHotline[language]);
$('.commonConectChina').html(commonCustomerServiceHotlineChina[language]);
$('.commonConectPhilippines').html(commonCustomerServiceHotlinePhilippines[language]);
$('.commonConectJapan').html(commonCustomerServiceHotlineJapan[language]);
$('.commonConectKorea').html(commonCustomerServiceHotlineKorea[language]);
$('.commonConectThailand').html(commonCustomerServiceHotlineThailand[language]);
$('.commonConectYh').html(commonCustomerServiceHotlineYh[language]);
$('.commonCompanyInfo').html(commonCompanyInfo[language]);
$('.commonCompanyBeianInfo').html(commonCompanyBeianInfo[language]);
$('.commonCompanyBeianText').html(commonCompanyBeianText[language]);
$('.commonCompanyLicense').html(commonCompanyLicense[language]);
$('.commonCompanyICP').html(commonCompanyICP[language]);
$('.simplyDesign').html(simplyDesign[language])
$('.simplyDesignType1').html(simplyDesignType1[language])
$('.simplyDesignType2').html(simplyDesignType2[language])
$('.simplyDesignType3').html(simplyDesignType3[language])
$('.simplyBrandIntroductionTitle').html(simplyBrandIntroductionTitle[language])
$('.simplyBrandIntroductionInfo').html(simplyBrandIntroductionInfo[language])
$('.simplyBrand1').html(simplyBrand1[language])
$('.simplyBrand1Introduction').html(simplyBrand1Introduction[language]);
$('.simplyBrand2Introduction').html(simplyBrand2Introduction[language]);
$('.commonLvyue1').html(commonLvyue1[language]);
$('.Leadership').html(Leadership[language]);
$('.TalentRecruitment').html(TalentRecruitment[language]);
$('.simplyBuildingaboutfbType1').html(homePageSwiperFourDesignideaInfo3[language]);
$('.simplyBuildingaboutfbType3').html(homePageSwiperFourBusinesstrip[language]);
$('.floralReservation').html(floralReservation[language]);

$('.commonBaina').html(commonBaina[language]);
$('.commonBanlan').html(commonBanlan[language]);



/** WEBPACK FOOTER **
 ** ./src/js/simplyLanguage.js
 **/